// removed by extract-text-webpack-plugin
module.exports = {"SmallDestinationCardWrapper":"src-components-SmallDestinationCard-__SmallDestinationCard-module___SmallDestinationCardWrapper","SmallDestinationCardLocation":"src-components-SmallDestinationCard-__SmallDestinationCard-module___SmallDestinationCardLocation","SmallDestinationCardPrice":"src-components-SmallDestinationCard-__SmallDestinationCard-module___SmallDestinationCardPrice"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SmallDestinationCard/SmallDestinationCard.module.css
// module id = 1023
// module chunks = 0